/**
 * Copyright (c) 2019 2020 7thCode. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {FormsModule} from "@angular/forms";

import {FlexLayoutModule} from "@angular/flex-layout";

import {MatButtonModule} from "@angular/material/button";
import {MatCardModule} from "@angular/material/card";
import {MatDialogModule} from "@angular/material/dialog";
import {MatGridListModule} from "@angular/material/grid-list";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";

import {BaseModule} from "../../platform/base/base.module";

import {InquiryDialogComponent} from "./inquiry-dialog/inquiry-dialog.component";
import {InquiriesComponent} from "./inquiries.component";

import {SessionService} from "../../platform/base/services/session.service";
import {InquiriesService} from "./inquiries.service";
import {AngularEditorModule} from "@kolkov/angular-editor";
import {MatSelectModule} from "@angular/material/select";
import {BasePipeModule} from "../../platform/base/pipes/base-pipe.module";
import {MatTooltipModule} from "@angular/material/tooltip";
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
	declarations: [
		InquiriesComponent,
		InquiryDialogComponent,
	],
	providers: [
		SessionService,
		InquiriesService,
	],
	imports: [
		CommonModule,
		FormsModule,

		FlexLayoutModule,

		MatDialogModule,
		MatCardModule,
		MatIconModule,
		MatButtonModule,
		MatInputModule,
		MatPaginatorModule,
		MatSlideToggleModule,
		MatGridListModule,

		BaseModule,
		AngularEditorModule,
		MatSelectModule,
		MatTooltipModule,

		BasePipeModule,
		TranslateModule
	],
	exports: [
		InquiriesComponent,
	],
	bootstrap: [
		InquiryDialogComponent,
	],
})

export class InquiriesModule {
}
